<mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div class="title-row">
          <span class="card-title">
            @if(!isInboxPage()){
            <span>Inbox</span>
            }
            <button mat-stroked-button (click)="refreshMessages()" [ngClass]="!isInboxPage() ? 'icon-only m-l-05' : 'icon-only'"><mat-icon>refresh</mat-icon></button>
          </span>
          <span class="action-links">
            @if (!isInboxPage()) {
              <a mat-button mat-stroked-button routerLink="/inbox" [matBadge]="totalUnreadMessageCount" matBadgeOverlap="true" matBadgePosition="before" [matBadgeHidden]="!totalUnreadMessageCount || totalUnreadMessageCount === 0"><mat-icon>inbox</mat-icon>Inbox</a>
            }
            <a mat-button mat-stroked-button routerLink="/sent"><mat-icon>outbox</mat-icon> Sent</a>
            <a mat-button mat-stroked-button routerLink="/messages"><mat-icon>search</mat-icon> Search</a>
            @if(clientMatterContactDetails && clientMatterContactDetails.enableMessaging){
              <a mat-button mat-flat-button [routerLink]="getComposeMessageRouterLink()"><mat-icon>add</mat-icon> {{newMessageText}}</a>
            }
          </span>
        </div>
      </mat-card-title>
    </mat-card-header>
  
    <mat-card-content>
      @if(loading){
      <div class="d-flex justify-content-center">
        <mat-spinner></mat-spinner>
      </div>
      }
      @if(pagedMessages != null){
        <app-message-list [pagedMessages]="pagedMessages"></app-message-list>
      }
      <!-- have the show more.. option if this is the home page otherwise have actual paging-->
      @if(pagedMessages != null && pagedMessages.totalCount > pagedMessages.pageSize && !isInboxPage()) {
        <a mat-button mat-stroked-button [routerLink]="['/inbox']" class="m-t-1">Show more...</a>
      }
    
       <mat-paginator [hidden]="!isInboxPage()"
                    (page)="handlePageEvent($event)"
                    [pageSizeOptions]="[5, 10, 20]"
                    [pageSize]="pageSize"
                    [pageIndex]="pageIndex"
                    [length]="pagedMessages?.totalCount || 0"           
                    showFirstLastButtons
                 aria-label="Select page of messages">
        </mat-paginator>
      
    </mat-card-content>
  </mat-card>
